<script setup lang="ts">
import TheNavLinks from "~/components/TheNavLinks.vue";

const year = new Date().getFullYear();
</script>

<template>
  <footer class="footer p-20 px-5 h-100 lg:justify-between lg:p-20 lg:gap-24 lg:px-10 lg:py-0 lg:align-middle gap-20 bg-base-300 text-base-content border-t border-base-100 grid lg:grid-cols-2 mt-40">

    <aside class="w-full order-2 lg:order-1 justify-center lg:justify-start lg:self-center">
      <img src="/scriptedpixels-logo--white.svg" width="300"
        alt="Scripted Pixes Logo" class="w-48 h-auto mx-auto lg:ml-0" />
      <p class="text-sm mb-0 mt-2 text-center lg:text-left w-full">
        DESIGN, DEVELOP, DELIVER<br />&copy; Scripted Pixels Ltd {{ year }}
      </p>

      <p class="text-xs max-w-96 text-center lg:text-left mb-0">
        <a href="https://logrocket.com" target="_blank"
          rel="noreferrer noopener">LogRocket</a>,
        <a href="https://sentry.io" target="_blank"
          rel="noreferrer noopener">Sentry</a>
        &nbsp; &
        <a href="https://clicky.com" target="_blank"
          rel="noreferrer noopener">Clicky</a>
        are used to monitor performance, errors & Analytics on the site 🤓
      </p>

      <p class="text-xs max-w-96 text-center lg:text-left w-full">
        Designed by me. Built with Nuxt.js, Vue, TailwindCSS, PrimeVue, DaisyUI
        and Netlify.
      </p>
    </aside>

    <aside class="w-full order-1 lg:order-2 lg:self-center">
      <nav class="nav flex gap-4 uppercase justify-center lg:justify-end lg:text-lg w-full">
        <TheNavLinks text-size="text-base" />
      </nav>

      <div
        class="alert bg-secondary text-secondary-content p-0 px-2 rounded-xs w-full lg:w-auto lg:ml-auto flex mt-5">
        <p class="m-0 w-full text-center p-2 text-sm font-mono hover:cursor-pointer"
          onclick="contactModal.showModal()">
          Available for part-time work 💻
        </p>
      </div>

      <ul
        class="flex gap-2.5 text-xs w-full px-0 mx-0 justify-center mt-5 lg:text-sm lg:justify-end lg:gap-5">
        <li>
          <a href="https://mastodon.social/@scriptedpixels"
            target="_blank">Mastodon
          </a>
        </li>
        <li>
          <a href="https://www.twitter.com/scriptedpixels"
            target="_blank">Twitter
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/kambanwait"
            target="_blank">LinkedIn
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/scriptedpixels/"
            target="_blank">Instagram
          </a>
        </li>
      </ul>
    </aside>
  </footer>
</template>
